import React, { Component } from 'react';
import VariaveisGlobais from './../utilites/variaveisDoSistema';

// import { Container } from './styles';

export default class ListProdutos extends Component {
  render() {
    const vglobais = new VariaveisGlobais();
    return (
      <div style={{
        display: 'flex',
        padding: '16px',
        background: 'transparent',
        cursor: 'pointer',
        borderRadius: 16,
        transition: 'all 0.3s ease',
        width: '100%',
        alignItems: 'center',
        gap: 16,
      }}
      onClick={() => this.props.acao()}>
        
        {/* Container da imagem melhorado */}
        <div style={{
          width: 80,
          height: 80,
          borderRadius: 12,
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: '2px solid rgba(165, 42, 42, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          flexShrink: 0,
        }}>
          {/* Efeito de brilho */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '40%',
            background: 'linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.1) 100%)',
            pointerEvents: 'none',
            borderRadius: '12px 12px 0 0',
          }} />
          
          <img
            src={vglobais.getHostIMG + '/pod/' + this.props.Imagem}
            alt={this.props.Nome}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'relative',
              zIndex: 1,
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentNode.style.background = '#f0f0f0';
              e.target.parentNode.innerHTML = '<div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; color: #999; font-size: 12px;">Sem imagem</div>';
            }}
          />
        </div>

        {/* Conteúdo principal */}
        <div style={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          gap: 6,
          minWidth: 0,
        }}>
          {/* Nome do produto */}
          <div style={{
            fontSize: 16,
            fontWeight: 'bold',
            color: '#333',
            lineHeight: 1.3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}>
            {this.props.Nome}
          </div>
          
          {/* Descrição */}
          {this.props.Obs && (
            <div style={{
              fontSize: 13,
              color: '#666',
              lineHeight: 1.4,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              marginBottom: 4,
            }}>
              {this.props.Obs}
            </div>
          )}
          
          {/* Preço */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            marginTop: 'auto',
          }}>
            <div style={{
              fontSize: 18,
              fontWeight: 'bold',
              color: '#a52a2a',
              fontFamily: 'monospace',
            }}>
              € {this.mascaraValor(parseFloat(this.props.Preco).toFixed(2))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor
  }


}
